<template>
  <dara-navbar>
    <template #right>
      <div class="d-flex align-items--center">
        <dara-input
          v-if="disabledInput"
          ref="inputSearchRef"
          v-model="inputSearch"
          :focus="focus"
          :placeholder="$t('search')"
          @keyup.enter="search" />
        <dara-icon
          v-if="!disableSearch"
          class="flex-fill mx--md"
          icon="search"
          @click="showInputSearch" />
        <dara-topbar-notification-panel />
        <dara-topbar-user-dropdown />
      </div>
    </template>
  </dara-navbar>
</template>

<script>
import { goToSearch } from '@/modules/my-space/my-space.routes';
import { MY_SPACE_URL } from '@/modules/my-space/my-space.constants';
import DaraTopbarUserDropdown from '@/components/topbar/TopbarUserDropdown.vue';
import DaraTopbarNotificationPanel from '@/components/topbar/TopbarNotificationPanel.vue';

export default {
  name: 'DaraTopbar',
  components: {
    DaraTopbarUserDropdown,
    DaraTopbarNotificationPanel,
  },
  data() {
    return {
      inputSearch: null,
      disableSearch: false,
      disabledInput: true,
      focus: false,
    };
  },
  mounted() {
    if (this.$router.currentRoute.path === MY_SPACE_URL.search.path) {
      this.disableSearch = true;
      this.disabledInput = false;
    }
  },
  methods: {
    search() {
      if (this.inputSearch) {
        goToSearch(this.$router, this.inputSearch);
      }
    },
    showInputSearch() {
      if (this.inputSearch) {
        goToSearch(this.$router, this.inputSearch);
      } else {
        this.disabledInput = !this.disabledInput;
        if (this.disabledInput) {
          this.focus = true;
        }
      }
    },
  },
};
</script>
